/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

// generate prototype of Error
/**
 * API exception type.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default class ApiException extends Error {
    constructor(public status: number, public response: any, public params: any = {}, public additional: any = {}) {
        super();
    }
}
